import { Component, Fragment } from 'react';

import { filter } from 'rxjs/operators';
import FeaturesTilesComponent from '../../components/ui/features-tiles/features-tiles.component';
import { MotiveComponent } from '../../components/ui/motive/motive.component';
import RatingDisplayComponent from '../../components/ui/rating-display/rating-display.component';
import { RelatedLinksComponent } from '../../components/ui/related-links/related-links.component';
import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { EnvironmentService } from '../../services/environment.service';
import { FileUploadService } from '../../services/file-upload.service';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { WindowService } from '../../services/window.service';
import { FileSelectEvent } from '../../types/file-upload.types';
import { PageData, RouteProps } from '../../types/route-types';
import { MotiveLocationTypes } from '../../utils/request.utils';
import { RouteUtils } from '../../utils/route.utils';
import FileUploadComponent from '../converter/file-upload/file-upload.component';
import styles from './image-resize-root.component.module.scss';
import { PhotoEditorComponent } from './photo-editor/photo-editor.component';
import Head from 'next/head';
import Script from 'next/script';

interface ImageResizeRootState {
    fileSelectBtnClicked: boolean;
    fileSelected: boolean;
}

export default class ImageResizeRootComponent extends Component<RouteProps, ImageResizeRootState> {
    public title: string;
    public description: string;
    public features: Array<any>;
    feature;

    fileSelectEvent: FileSelectEvent = null;


    // Does this work, if works do it on other places as well
    @lazyInject(IOC_TYPES.EnvironmentService) envService: EnvironmentService;
    @lazyInject(IOC_TYPES.PageDataProviderService) pageDataProviderService: PageDataProviderService;
    @lazyInject(IOC_TYPES.FileUploadService) fileUploadService: FileUploadService;
    @lazyInject(IOC_TYPES.WindowService) windowService: WindowService;

    readonly state: Readonly<ImageResizeRootState> = {
        fileSelectBtnClicked: false,
        fileSelected: false,
    };
    constructor(props) {
        super(props);
        this.feature = RouteUtils.getPathFromProps(props);
        this.updatePageData(props.pageData);
    }

    componentDidMount() {
        const componentMountedTime = Date.now();
        this.windowService.onFileSelectBtnClicked.pipe(
            filter(evt => evt.dispatchedAt.getTime() > componentMountedTime)
        ).subscribe({
            next: () => {
                // if (!this.state.fileSelectBtnClicked) {
                //     this.setState({
                //         fileSelectBtnClicked: true,
                //     });
                // }
            }
        })
        // this.fileUploadService.onFileSelected.pipe(
        //     filter(evt => evt.dispatchedAt.getTime() > componentMountedTime)
        // ).subscribe({
        //     next: (data) => {
        //         if (!this.state.fileSelected) {
        //             this.setState({
        //                 fileSelected: true,
        //             });
        //         }
        //     }
        // });
    }

    fileSelected(event: FileSelectEvent) {
        this.fileSelectEvent = event;
        if (!this.state.fileSelectBtnClicked) {
            this.setState({
                fileSelectBtnClicked: true,
            });
        }

        if (!this.state.fileSelected) {
            this.setState({
                fileSelected: true,
            });
        }
    }

    private updatePageData(value: PageData) {
        this.features = value.page_seo.feature;
        this.title = value.page_seo.title;
        this.description = value.page_seo.description && value.page_seo.description.replace(/\s+/g, ' ');
    }

    private getSEOContent() {
        return <div className={`col-12 col-sm-12 col-md-12 col-lg-12 pt-5`}>
            <div className={`row text-center`}>
                {
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3" >
                        <RelatedLinksComponent relatedLinks={this.props.relatedLinks}></RelatedLinksComponent>
                    </div>
                }

                {
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3" >
                        <RatingDisplayComponent
                            rating={this.props.rating}
                            title={this.title}
                            feature={this.feature}
                            description={this.description}>
                        </RatingDisplayComponent>
                    </div>
                }
                {
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                        {
                            this.features && <FeaturesTilesComponent features={this.features}></FeaturesTilesComponent>
                        }
                    </div>
                }
            </div>
        </div>;
    }

    startNew() {
        this.fileSelectEvent = null;
        this.setState({
            fileSelectBtnClicked: false,
            fileSelected: false,
        });
    }

    render() {
        if(!this.state.fileSelected) {
            return <div className={`row nav-padding ${styles['image-resize-root']}`}>
            {
                !this.state.fileSelectBtnClicked && <div className={`col-12 col-sm-12 col-md-12 col-lg-12 text-center ${styles['page-heading']}`}>
                    <h1 className={`${styles.title}`}><b>{this.title}</b></h1>
                    <p className={`${styles.description} ${styles["secondary-text"]}`}>{this.description}</p>
                </div>
            }
            <div className="col-12">
                {
                    <div className="gcontent-container">
                        <MotiveComponent
                            data="8711788873"
                            containerWidth="100%"
                            containerHeight="90px"
                            location={MotiveLocationTypes.convertPageTop}
                            adWidth="970px"
                            adHeight="90px"
                            showAds={true}
                            className='width_major'
                        ></MotiveComponent>
                    </div>
                }
            </div>
            <div className={`col-12 col-sm-12 col-md-12 col-lg-12`}>
                <div className={`row nav-padding static-section ${styles['static-sectionpage-heading']}`}>
                    <div className={`col-2 col-sm-2 col-md-4 col-lg-4`}></div>
                    <div className={`col-8 col-sm-8 col-md-4 col-lg-4`}>
                        <FileUploadComponent {...this.props}
                            fileSelected={$event => this.fileSelected($event)}
                            fileSelectButtonClicked={() => console.log('Clicked')}
                            shouldDisplayBtnsAsPrimary={true}
                            acceptedFileTypes="image/*"
                            uploadBtnText="Select Image" showGoogleDrive={false} showDropbox={false}
                            uploadBtnClassName='btn-primary'>
                        </FileUploadComponent>
                    </div>
                    <div className={`col-2 col-sm-2 col-md-4 col-lg-4`}></div>
                </div>
            </div>

            {
                !this.state.fileSelectBtnClicked && this.getSEOContent()
            }
        </div>
        }
        if (false && !this.state.fileSelectBtnClicked) {
            return <div className={`row nav-padding ${styles['image-resize-root']}`}>
                {
                    !this.state.fileSelectBtnClicked && <div className={`col-12 col-sm-12 col-md-12 col-lg-12 text-center ${styles['page-heading']}`}>
                        <h1 className={`${styles.title}`}><b>{this.title}</b></h1>
                        <p className={`${styles.description} ${styles["secondary-text"]}`}>{this.description}</p>
                    </div>
                }
                <div className="col-12">
                    {
                        <div className="gcontent-container">
                            <MotiveComponent
                                data="8711788873"
                                containerWidth="100%"
                                containerHeight="90px"
                                location={MotiveLocationTypes.convertPageTop}
                                adWidth="970px"
                                adHeight="90px"
                                showAds={true}
                                className='width_major'
                            ></MotiveComponent>
                        </div>
                    }
                </div>
                <div className={`col-12 col-sm-12 col-md-12 col-lg-12`}>
                    <div className={`row nav-padding static-section ${styles['static-sectionpage-heading']}`}>
                        <div className={`col-2 col-sm-2 col-md-4 col-lg-4`}></div>
                        <div className={`col-8 col-sm-8 col-md-4 col-lg-4`}>
                            <FileUploadComponent {...this.props}
                                fileSelected={$event => this.fileSelected($event)}
                                fileSelectButtonClicked={() => console.log('Clicked')}
                                shouldDisplayBtnsAsPrimary={true}
                                acceptedFileTypes="image/*"
                                uploadBtnText="Select Image" showGoogleDrive={false} showDropbox={false}
                                uploadBtnClassName='btn-primary'>
                            </FileUploadComponent>
                        </div>
                        <div className={`col-2 col-sm-2 col-md-4 col-lg-4`}></div>
                    </div>
                </div>

                {
                    !this.state.fileSelectBtnClicked && this.getSEOContent()
                }
            </div>
        }

        if (false && !this.state.fileSelected) {
            return <div className={`col-12 col-sm-12 col-md-12 col-lg-12`}>
                <div className={`row nav-padding static-section ${styles['static-sectionpage-heading']}`}>
                    <div className={`col-12 col-sm-12 col-md-12 col-lg-12`}>
                        <FileUploadComponent {...this.props}
                            fileSelected={$event => this.fileSelected($event)}
                            fileSelectButtonClicked={() => console.log('Clicked')}
                            shouldDisplayBtnsAsPrimary={true}
                            acceptedFileTypes="image/*"
                            uploadBtnText="Select Image" showGoogleDrive={false} showDropbox={false}
                            uploadBtnClassName='btn-primary'>
                        </FileUploadComponent>
                    </div>
                </div>
            </div>;
        }
        return <>
        <Head>
            <Script defer async type="text/javascript" src='/js/lib/glfx.6.min.js'></Script>
        </Head>
        <PhotoEditorComponent
            {...this.props}
            fileSelectEvent={this.fileSelectEvent}
            startNew={() => this.startNew()}
        ></PhotoEditorComponent>
        </> 
    }
}
